import { baseVariables, toRem } from '@marriott/mi-ui-library';
import styled from 'styled-components';
import { chatKeyboardFocusVisible } from '../../styles/chatFocus';

interface WrapperProps {
  isActive: boolean;
}

interface ActionProps {
  action: 'save' | 'cancel';
}

export const NavActionWrapper = styled.li<WrapperProps>`
  width: 100%;
  position: relative;
  cursor: pointer;
  font-size: ${toRem(14)};
  font-weight: 500;
  color: ${baseVariables.color['base10']};
  white-space: nowrap;
  text-overflow: ellipsis;
  padding: 0;
  font-size: ${toRem(14)};
`;

export const ChatActions = styled.div<WrapperProps>`
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${toRem(32)};
  visibility: hidden;
  pointer-events: none;
  line-height: 0;
`;

export const NavItemWrapper = styled.div<WrapperProps>`
  position: relative;
  box-sizing: border-box;
  width: calc(100% + 16px);
  display: inline-flex;
  align-items: center;
  min-height: ${toRem(32)};
  gap: ${toRem(8)};
  border-radius: 8px;
  margin: 0 ${toRem(-8)};
  padding: ${toRem(4)} ${toRem(8)};
  padding-right: ${toRem(32)};
  background-color: transparent;

  &:hover {
    background-color: ${baseVariables.color['neutral20']};

    .chat-actions {
      visibility: visible;
      pointer-events: auto;
    }
  }

  @media (max-width: 767px) {
    min-height: ${toRem(40)};
    padding: ${toRem(8)};
    padding-right: ${toRem(32)};
  }
`;

export const NavItemSelectButton = styled.button`
  -webkit-appearance: none;
  appearance: none;
  display: flex;
  flex-grow: 1;
  min-width: 0;
  border: none;
  background: transparent;
  padding: 0;
  text-align: left;
  cursor: pointer;
  font: inherit;
  color: inherit;
  ${chatKeyboardFocusVisible}
`;

export const Text = styled.span`
  color: ${baseVariables.color['base10']};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const NavAction = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  color: ${baseVariables.color['base10']};
  padding: 0;
`;

export const RenameInput = styled.input`
  font-size: 16px !important;
  line-height: ${toRem(24)};
  border-radius: ${toRem(4)};
  outline: none;
  flex: 1;
  min-width: 0;
  width: 100%;
  border: none !important;
  padding: 0 !important;

  @media ${baseVariables.mediaQuery.lg} {
    font-size: ${toRem(14)} !important;
    line-height: ${toRem(20)};
  }
`;

export const RenameAction = styled.button<ActionProps>`
  background: ${({ action }) => (action === 'save' ? baseVariables.color['alert30'] : baseVariables.color['alert50'])};
  color: ${baseVariables.color['white']};
  border: none;
  border-radius: ${toRem(4)};
  padding: ${toRem(6)} ${toRem(8)};
  cursor: pointer;
`;

export const RenameInputWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${toRem(8)};
`;

/** Wraps rename input so mobile keyboard Done/OK submits via onSubmit. */
export const RenameForm = styled.form`
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
  width: 100%;
`;
